import(/* webpackMode: "eager" */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/src/components/blocks/LegalContent.tsx");
